import { render, staticRenderFns } from "./membercenter.vue?vue&type=template&id=5de49a73&scoped=true&"
import script from "./membercenter.vue?vue&type=script&lang=js&"
export * from "./membercenter.vue?vue&type=script&lang=js&"
import style0 from "./membercenter.vue?vue&type=style&index=0&id=5de49a73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de49a73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de49a73')) {
      api.createRecord('5de49a73', component.options)
    } else {
      api.reload('5de49a73', component.options)
    }
    module.hot.accept("./membercenter.vue?vue&type=template&id=5de49a73&scoped=true&", function () {
      api.rerender('5de49a73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/membercenter.vue"
export default component.exports